import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { Popover } from '@mui/material'

import { useLazyFetchWorkOrdersDisposalTicketQuery } from 'api/work-order/getWorkOrdersDisposalTicket'
import { Z_INDEX } from 'theme/zIndex'

import DisposalTicketListing from './DisposalTicketListing'

const DisposalTicketPopoverV2 = ({
  anchorEl,
  workOrderId,
  configuredServiceId,
  onClose,
  transformOrigin = { vertical: 'top', horizontal: 'left' },
}) => {
  const isOpen = Boolean(anchorEl)
  const [getWorkOrdersDisposalTicket, { data: disposalTicketData, isFetching: isGetWorkOrdersDisposalTicketLoading }] =
    useLazyFetchWorkOrdersDisposalTicketQuery()

  useEffect(() => {
    if (isOpen && workOrderId) {
      getWorkOrdersDisposalTicket(workOrderId)
    }
  }, [isOpen, workOrderId])

  return (
    <>
      <Popover
        sx={{ pointerEvents: 'none', zIndex: Z_INDEX.BADGE_POPOVER }}
        open={isOpen}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={transformOrigin}
        onClose={onClose}
        disableRestoreFocus
        slotProps={{ paper: { sx: { minWidth: 600 } } }}
      >
        <DisposalTicketListing
          workOrderId={workOrderId}
          configuredServiceId={configuredServiceId}
          isLoading={isGetWorkOrdersDisposalTicketLoading}
          disposalTicketData={isGetWorkOrdersDisposalTicketLoading ? null : disposalTicketData}
        />
      </Popover>
    </>
  )
}

DisposalTicketPopoverV2.propTypes = {
  anchorEl: PropTypes.object,
  workOrderId: PropTypes.string.isRequired,
  configuredServiceId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  transformOrigin: PropTypes.object,
}

export default DisposalTicketPopoverV2
